module.exports = __webpack_public_path__ + "static/oljeskift_small-4f6494448c1b5acf5690726b0ddd294a.png";